import React from 'react';
import { states } from '@/constants/lifecycle';
import NotificationsFilters from './NotificationsFilters';
import { defaultEvent } from '../subscribers/helper';
import NotificationsPanelContainer from './NotificationsPanelContainer';
import NotificationsPanelHeader from './NotificationsPanelHeader';
import NotificationCards from './NotificationCards';
import SubscriptionEventLabel from '../subscribers/components/SubscriptionEventLabel';
import Selectors from '../hooks/selectors';

const NotificationsPanelNarrow = ({
  category,
  code,
  onChange,
  url,
}) => {
  const event = defaultEvent(category);
  const { name, readStatus } = Selectors.useNotificationsPanelNarrow({ category, code, event });

  return (
    <NotificationsPanelContainer
      category={category}
      className="aridhia-notifications-panel-narrow"
      code={code}
      onChange={onChange}
      url={url}
    >
      <div className="sticky-panel-header">
        {code && (
        <NotificationsPanelHeader
          category={category}
          code={code}
          isLoading={readStatus === states.PENDING}
          value={name}
        />
        )}
        {event && (<SubscriptionEventLabel event={event} className="dn" />)}
        <NotificationsFilters category={category} code={code} event={event} className="aridhia-list-filter" fluid />
      </div>
      <NotificationCards category={category} code={code} event={event} itemsPerRow={1} />
    </NotificationsPanelContainer>
  );
};

export default NotificationsPanelNarrow;
